// The project-wide list is the same backend function the Design log uses; the
// workspace only needs the summary fields, so re-export rather than duplicate.
export { DESIGN_PACKAGE_LIST_VIEW as QUERY_PLANNING_WORKSPACE_LIST } from "pages/design-package-log-page/queries";

// Every live bid package in the project (feature type 4). milestone_state /
// risk_level back the Split modal's Status and Risk columns: milestone_state is
// the BP's current milestone name ("Bid Package Initiated"), risk_level the
// server-computed LOW/MEDIUM/HIGH level.
export const BID_PACKAGE_LIST_QUERY_MIN = `BidPackageListQueryMin {
  feature_instance(where: {feature_type_id: {_eq: 4}, deleted: {_eq: false}}) {
    id
    auto_inc_value
    number
    title
    feature_workflow_instance {
      risk_level
      milestone_state
    }
  }
}`;
